module.exports = "https://static.wmbcdn.com/uniweb/images/2a45bca4543d9241dffbc5add8f1743b.svg";